import React, {Fragment, useEffect, useRef, useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import CheckoutCollapse from '../Components/Checkout.Collapse';
import CheckoutOrderInfo from '../Components/Checkout.OrderInfo';
import PaymentWidget from '../Components/Payments/PaymentWidget';
import CheckoutAssemblyCheckbox from '../Components/Checkout.AssemblyCheckbox';
import CheckoutEnjoyClubCollapse from '../Components/Checkout.EnjoyClubCollapse';

import {
  setBusinessCustomer,
  setCampaignCode,
  setCountry,
  setDelivery,
  setPayment,
  setOrderNote,
  submit,
  verify,
  setCustomerDetails,
  setSignUp,
  setSelectedReseller,
  setIsAssemblyAllowed,
  setWithAssembly,
  submitError,
  reloadPayment,
  submitCampaignCode,
  setBonus,
  submitRequest,
  submitDone,
  signUpForEnjoy,
  clearSubmitError,
  setPaymentAndDelivery,
  setAlternativeCompanyAddress,
} from '../Actions/Checkout.action';
import {
  loadError,
  receive,
  update as updateOrderRowQuantity,
} from '../Actions/Cart.action';

import { translate } from '../Services/translation';
import { string, object } from 'yup';
import { get } from '../Services/http';
import RenderCouponSection from '../Components/Checkout/RenderCouponSection';
import RenderPaymentMethodsSection from '../Components/Checkout/RenderPaymentMethodsSection';
import {
  CHECKOUT_B2B_PAYMENT,
  CHECKOUT_B2B_SHIPPING,
  CHECKOUT_KLARNA_PAYMENT,
  CHECKOUT_KLARNA_SHIPPING,
  CHECKOUT_PICK_UP_PAYMENT,
  CHECKOUT_PICK_UP_SHIPPING,
  CHECKOUT_STEP_CART,
  CHECKOUT_STEP_LOYALTY,
  CHECKOUT_STEP_PAYMENT,
  CHECKOUT_STEP_PAYMENTSELECT,
} from '../Components/Checkout/CheckoutConst';
import RenderCustomerDetailsSection from '../Components/Checkout/RenderCustomerDetailsSection';
import RenderCartSection from '../Components/Checkout/RenderCartSection';
import { add as addToCartService } from '../Services/Cart.service';
import { catchError } from '../Actions/Error.action';
import CheckoutProductListAutoSelect from '../Components/Checkout/CheckoutProductListAutoSelect';

const privateCustomerAdditionalDetailsSchema = object().shape({
  selectedDeliveryMethod: string().required(translate(`validation.required`)),
});

const privateCustomerAddressSchema = object().shape({
  email: string()
      .required(translate(`validation.required`))
      .email(translate(`validation.email`)),
  phoneNumber: string().required(translate(`validation.required`)),
  lastName: string().required(translate(`validation.required`)),
  firstName: string().required(translate(`validation.required`)),
});

const businessCustomerDetailsSchema = object().shape({
  selectedDeliveryMethod: string().required(translate(`validation.required`)),
  email: string()
      .required(translate(`validation.required`))
      .email(translate(`validation.email`)),
  phoneNumber: string().required(translate(`validation.required`)),
  lastName: string().required(translate(`validation.required`)),
  firstName: string().required(translate(`validation.required`)),
});

const CheckoutContainer = (props = {}) => {
  const {
    checkout,
    onCustomerDetailsChange,
    submit,
    submitError,
    submitRequest,
    cart,
    setWithAssembly,
    privacy,
    setSelectedReseller,
    onSignUpChange,
    setBonus,
    updateOrderRowQuantity,
    removeOrderRow,
    submitCampaignCode,
    setCampaignCode,
    signUpForEnjoy,
    verify,
    setOrderNote,
    onCartBuy,
    constants: storeConstants,
    setPaymentAndDelivery: setPaymentAndDeliveryAction,
  } = props;
  const { payload, errors: checkoutErrors, isSubmitting } = checkout || {};
  const {
    paymentWidget,
    loginUrl,
    paymentMethods,
    authenticated,
    isBusinessCustomer,
    checkoutMode,
    selectedPaymentMethod,
    selectedResellerId,
    isAssemblyAllowed,
    bonusToEarn,
    enjoyClubDescription,
    isDeliveryLoading,
    isPaymentLoading,
    deliveryMethods,
    selectedDeliveryMethod,
    customerDetails,
    signUp,
    bonusImage,
    signedUpForEnjoy,
    withAssembly,
    orderCurrency,
    orderTotal
  } = payload || {};

  const constants = {
    ...storeConstants,
  }

  const country = constants?.currentCountry || window.__litium.constants.currentCountry;

  const stepRefs = useRef([]);
  const [checkoutStep, setCheckoutStep] = useState(1);
  const [enjoyClub, setEnjoyClub] = useState({
    canJoin: false,
    isMember: false,
  });

  const changeCheckoutStep = (step) => {
    setCheckoutStep(step);

    setTimeout(() => {
      window.scrollTo({
        behavior: 'smooth',
        top: stepRefs.current[step].getBoundingClientRect().top - 70
      })
    }, 200)
  }

  const setPaymentAndDelivery = (paymentMethod) => {
    if (payload) {
      if (!isBusinessCustomer) {
        // Is B2C
        // Get the B2C delivery methods
        const klarnaShippingMethod = deliveryMethods.find(
            (x) => x && x.id === CHECKOUT_KLARNA_SHIPPING
        );
        const pickUpShippingMethod = deliveryMethods.find(
            (x) => x && x.id === CHECKOUT_PICK_UP_SHIPPING
        );

        // Has user clicked "Click and collect" when adding last product?
        const buyAndCollectClicked = localStorage.getItem(
            'isBuyAndCollectButton'
        );

        // If no selected payment or delivery options (i.e. first time checkout)
        if (
            !selectedPaymentMethod ||
            selectedDeliveryMethod == '00000000-0000-0000-0000-000000000000'
        ) {
          if (buyAndCollectClicked && buyAndCollectClicked === '1') {
            // setPayment(CHECKOUT_PICK_UP_PAYMENT);
            // setDelivery(pickUpShippingMethod.systemId);
            setPaymentAndDeliveryAction(
                CHECKOUT_PICK_UP_PAYMENT,
                pickUpShippingMethod.systemId
            );
            return;
          } else {
            // setPayment(CHECKOUT_KLARNA_PAYMENT);
            // setDelivery(klarnaShippingMethod.systemId);
            setPaymentAndDeliveryAction(
                CHECKOUT_KLARNA_PAYMENT,
                klarnaShippingMethod.systemId
            );
            return;
          }
        }

        // User clicked on "Click and collect" when adding last product
        if (
            selectedPaymentMethod !== CHECKOUT_PICK_UP_PAYMENT &&
            buyAndCollectClicked === '1'
        ) {
          // setPayment(CHECKOUT_PICK_UP_PAYMENT);
          // setDelivery(pickUpShippingMethod.systemId);
          setPaymentAndDeliveryAction(
              CHECKOUT_PICK_UP_PAYMENT,
              pickUpShippingMethod.systemId
          );
          return;
        }

        // Klarna checkout is picked, but not initialized paymentWidget
        if (selectedPaymentMethod === CHECKOUT_KLARNA_PAYMENT && !paymentWidget) {

          const klarna = CHECKOUT_KLARNA_PAYMENT;
          // setPayment(CHECKOUT_KLARNA_PAYMENT);
          // setDelivery(klarnaShippingMethod.systemId);
          setPaymentAndDeliveryAction(
              klarna,
              klarnaShippingMethod.systemId
          );
          return;
        }

        // User changed payment method
        if (selectedPaymentMethod && paymentMethod !== selectedPaymentMethod) {
          if (paymentMethod === CHECKOUT_KLARNA_PAYMENT) {
            // setPayment(CHECKOUT_KLARNA_PAYMENT);
            // setDelivery(klarnaShippingMethod.systemId);
            setPaymentAndDeliveryAction(
                CHECKOUT_KLARNA_PAYMENT,
                klarnaShippingMethod.systemId
            );
            return;
          }
          if (paymentMethod === CHECKOUT_PICK_UP_PAYMENT) {
            // setPayment(CHECKOUT_PICK_UP_PAYMENT);
            // setDelivery(pickUpShippingMethod.systemId);
            setPaymentAndDeliveryAction(
                CHECKOUT_PICK_UP_PAYMENT,
                pickUpShippingMethod.systemId
            );
            return;
          }
        }
      } else {
        // Is B2B
        // Get the B2B delivery methods
        const b2bShippingMethod = deliveryMethods.find(
            (x) => x.id === CHECKOUT_B2B_SHIPPING
        );

        // If selected payment or delivery method is not set
        if (!selectedPaymentMethod || !selectedDeliveryMethod) {
          // setPayment(CHECKOUT_B2B_PAYMENT);
          // setDelivery(b2bShippingMethod.systemId);
          setPaymentAndDeliveryAction(
              CHECKOUT_B2B_PAYMENT,
              b2bShippingMethod.systemId
          );
        }

        // "Force user" to use B2B checkout and delivery methods
        if (
            selectedPaymentMethod !== selectedPaymentMethod ||
            selectedDeliveryMethod !== b2bShippingMethod.systemId
        ) {
          // setPayment(CHECKOUT_B2B_PAYMENT);
          // setDelivery(b2bShippingMethod.systemId);
          setPaymentAndDeliveryAction(
              CHECKOUT_B2B_PAYMENT,
              b2bShippingMethod.systemId
          );
        }
      }
    }
  };

  useEffect(() => {
    if (window.dataLayer?.find(el => el['gtm.start'])) {
      window.dataLayer.push({
        'event': 'begin_checkout',
        'ecommerce': {
          'currency': orderCurrency,
          'value': orderTotal,
          'items': cart.orderRows.map(row => {
            return {
              'item_id': row.articleNumber,
              'item_name': row.name,
              'currency': orderCurrency,
              'quantity': row.quantity,
              'item_category': row.category,
              'url': row.url
            }
          })
        }
      })
    }

    if (selectedPaymentMethod) {
      // set selected value for payment method on load.
      setPaymentAndDelivery(selectedPaymentMethod);
    }
    if (customerDetails) {
      // fill default select value to the state
      (!customerDetails || !customerDetails.country) &&
      constants.countries &&
      constants.countries[0] &&
      onCustomerDetailsChange(
          'customerDetails',
          'country',
          constants.countries[0].value
      );
    }
    if (authenticated) {
      get('/api/enjoyClub/check').then((response) => {
        response.json().then((data) => {
          setEnjoyClub({
            canJoin: !data,
            isMember: data,
          });
        });
      });
    }
  }, []);

  const placeOrder = () => {
    const { isBusinessCustomer, selectedPaymentMethod, selectedDeliveryMethod } =
        payload;
    const notCustomerDetailFields = [
      'selectedPaymentMethod',
      'selectedDeliveryMethod',
    ];
    const onError = (error, addressPath = 'customerDetails') => {
      error.path =
          notCustomerDetailFields.indexOf(error.path) >= 0
              ? error.path
              : `${addressPath}-${error.path}`;
      submitError(error);
    };
    submitRequest();

    if (isBusinessCustomer) {
      businessCustomerDetailsSchema
          .validate({
            ...payload.customerDetails,
            selectedPaymentMethod,
            selectedDeliveryMethod,
          })
          .then(() => {
            submit();
          })
          .catch(onError);
    } else {
      privateCustomerAddressSchema
          .validate({
            ...payload.customerDetails,
          })
          .then(() => {
            payload.showAlternativeAddress = false;

            privateCustomerAdditionalDetailsSchema
                .validate({
                  selectedPaymentMethod,
                  selectedDeliveryMethod,
                })
                .then(() => {
                  submit();
                })
                .catch(onError);
          })
          .catch(onError);
    }
  };

  const checkoutStepClass = (id) => {
    return `${checkoutStep === id ? 'active' : ''} ${
        checkoutStep < id ? 'disabled' : ''
    }`;
  };

  useEffect(() => {
    if (checkout && checkout.result && checkout.result.redirectUrl) {
      window.location = checkout.result.redirectUrl;
    } else {
      // wipe SelectedReseller when the PaymentMethod changed
      if (
          selectedPaymentMethod != CHECKOUT_PICK_UP_PAYMENT &&
          selectedResellerId != null
      ) {
        setSelectedReseller(null);
      }

      // signUp should be false for all guests
      if (!authenticated && signUp != false) {
        onSignUpChange(false);
      }

      if (!isSubmitting || !errors) {
        return;
      }

      const errorKeys = Object.keys(errors);
      if (!errorKeys || errorKeys.length < 1) {
        return;
      }

      const errorNode = document.querySelector(
          `[data-error-for="${errorKeys[0]}"]`
      );
      if (!errorNode) {
        return;
      }

      const inputNode = errorNode.parentElement.querySelector('input');
      if (inputNode) {
        setTimeout(() => inputNode.focus(), 1000);
        inputNode.scrollIntoView({
          behavior: 'smooth',
        });
      } else {
        errorNode.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }
  }, [checkout]);

  const [showErrors, setShowErrors] = useState(false);
  const [originalErrors, setOriginalErrors] = useState({});
  const errors = {
    general: [...(checkoutErrors?.general || [])],
  };

  useEffect(() => {
    if (errors && errors.general && errors.general.length > 0) {
      if (JSON.stringify(originalErrors) !== JSON.stringify(errors)) {
        setOriginalErrors(errors);
        setShowErrors(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errors?.general]);

  return (
      <>
        {/* Error messages */}
        <div
            className={
                'callout alert margin-top-1 margin-bottom-2 checkout-errors' +
                ` ${showErrors ? 'checkout-errors--active' : ''}`
            }
        >
          {errors['general'].length > 1 ? (
              <ul className="checkout__validator--error">
                {errors['general'].map((error, index) => {
                  return <li key={index}>{error}</li>;
                })}
              </ul>
          ) : (
              <p className="checkout__validator--error">{errors['general'][0]}</p>
          )}

          <button
              className="checkout-errors__close"
              onClick={() => setShowErrors(false)}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        {/*/!* Cart Steps *!/*/}
        <div
            className={`checkout__step cart-step ${checkoutStepClass(
                CHECKOUT_STEP_CART
            )}`}
            ref={el => stepRefs.current[CHECKOUT_STEP_CART] = el}
        >
          <div className="checkout__step-bar">
          <span className="checkout__step-title">
            {translate('checkout.cart.title')}
          </span>
            <span
                className="checkout__step-edit"
                onClick={() => changeCheckoutStep(CHECKOUT_STEP_CART)}
            >
            {translate('checkout.step.edit')}
          </span>
          </div>
          <div className="checkout__step-content">
            {isBusinessCustomer && (
                <CheckoutProductListAutoSelect
                    onSelect={(id) => {
                      onCartBuy(id, 1, cart);
                    }}
                />
            )}
            {!(!cart || !cart.orderRows || cart.orderRows.length < 1) ? (
                <>
                  {!paymentWidget || paymentWidget.isChangeable ? (
                      <RenderCartSection
                          cart={cart}
                          payload={payload}
                          errors={errors}
                          setBonus={setBonus}
                          updateOrderRowQuantity={updateOrderRowQuantity}
                          removeOrderRow={removeOrderRow}
                          enjoyClub={enjoyClub}
                      />
                  ) : null}

                  {!isBusinessCustomer && (
                      <RenderCouponSection
                          checkout={checkout}
                          submitCampaignCode={submitCampaignCode}
                          setCampaignCode={setCampaignCode}
                      />
                  )}

                  <div className="checkout-info__summary">
                    <CheckoutOrderInfo
                        cart={cart}
                        isBusinessCustomer={isBusinessCustomer}
                        hideDelivery={selectedPaymentMethod == CHECKOUT_PICK_UP_PAYMENT}
                    />
                  </div>

                  <div className="checkout__step-content-next">
                    <button
                        className="button"
                        type="button"
                        onClick={() =>
                            changeCheckoutStep(
                                authenticated
                                    ? isBusinessCustomer
                                        ? CHECKOUT_STEP_PAYMENT
                                        : enjoyClub.isMember
                                            ? CHECKOUT_STEP_PAYMENTSELECT
                                            : CHECKOUT_STEP_LOYALTY
                                    : CHECKOUT_STEP_LOYALTY
                            )
                        }
                    >
                      {translate('checkout.step.next')}
                    </button>
                  </div>
                </>
            ) : null}
          </div>
        </div>
        {!(!cart || !cart.orderRows || cart.orderRows.length < 1) ? (
            <>
              {(!authenticated || !enjoyClub.isMember) && !isBusinessCustomer && (
                  <div
                      className={`checkout__step loyalty-step ${checkoutStepClass(
                          CHECKOUT_STEP_LOYALTY
                      )}`}
                      ref={el => stepRefs.current[CHECKOUT_STEP_LOYALTY] = el}
                  >
                    <div className="checkout__step-bar">
                <span className="checkout__step-title">
                  {translate('checkout.loyalty.title')}
                </span>
                      <span
                          className="checkout__step-edit"
                          onClick={() => changeCheckoutStep(CHECKOUT_STEP_LOYALTY)}
                      >
                  {translate('checkout.step.edit')}
                </span>
                    </div>
                    <div className="checkout__step-content">
                      <div className="checkout__step__enjoy">
                        <CheckoutEnjoyClubCollapse
                            enjoyClubDescription={enjoyClubDescription}
                            imageUrl={bonusImage}
                            bonus={bonusToEarn}
                            loginUrl={loginUrl}
                            signedUpForEnjoy={signedUpForEnjoy}
                            onSignUpForEnjoy={signUpForEnjoy}
                        />
                      </div>
                      <div className="checkout__step-content-next">
                        <button
                            className="button"
                            type="button"
                            onClick={() => changeCheckoutStep(CHECKOUT_STEP_PAYMENTSELECT)}
                        >
                          {translate('checkout.step.next')}
                        </button>
                      </div>
                    </div>
                  </div>
              )}

              {!isBusinessCustomer && (
                  <div
                      className={`checkout__step payment-select-step ${checkoutStepClass(
                          CHECKOUT_STEP_PAYMENTSELECT
                      )}`}
                      ref={el => stepRefs.current[CHECKOUT_STEP_PAYMENTSELECT] = el}
                  >
                    <div className="checkout__step-bar">
                <span className="checkout__step-title">
                  {translate('checkout.payment_select.title')}
                </span>
                      <span
                          className="checkout__step-edit"
                          onClick={() => changeCheckoutStep(CHECKOUT_STEP_PAYMENTSELECT)}
                      >
                  {translate('checkout.step.edit')}
                </span>
                    </div>
                    <div className="checkout__step-content">
                      {paymentMethods &&
                          paymentMethods.length > 1 &&
                          (!Object(paymentWidget).keys || paymentWidget.isChangeable) && (
                              <RenderPaymentMethodsSection
                                  checkout={checkout}
                                  setPaymentAndDelivery={setPaymentAndDelivery}
                                  setSelectedReseller={setSelectedReseller}
                              />
                          )}

                      <div className="checkout__step-content-next">
                        {(selectedPaymentMethod == CHECKOUT_KLARNA_PAYMENT ||
                            selectedResellerId != null) &&
                        !isDeliveryLoading &&
                        !isPaymentLoading ? (
                            <button
                                className="button"
                                type="button"
                                onClick={() => changeCheckoutStep(CHECKOUT_STEP_PAYMENT)}
                            >
                              {translate('checkout.step.next')}
                            </button>
                        ) : (
                            <button className="button" type="button" disabled>
                              {translate('checkout.step.next')}
                            </button>
                        )}
                      </div>
                    </div>
                  </div>
              )}

              <div
                  className={`checkout__step payment-step ${checkoutStepClass(
                      CHECKOUT_STEP_PAYMENT
                  )}`}
                  ref={el => stepRefs.current[CHECKOUT_STEP_PAYMENT] = el}
              >
                <div className="checkout__step-bar">
              <span className="checkout__step-title">
                {translate('checkout.payment.title')}
              </span>
                  <span
                      className="checkout__step-edit"
                      onClick={() => changeCheckoutStep(CHECKOUT_STEP_PAYMENT)}
                  >
                {translate('checkout.step.edit')}
              </span>
                </div>
                <div className="checkout__step-content">
                  {!isBusinessCustomer && (
                      <PaymentWidget {...paymentWidget} verify={verify} />
                  )}

                  {((!Object(paymentWidget).keys && selectedPaymentMethod === CHECKOUT_PICK_UP_PAYMENT) || isBusinessCustomer) && (
                      <Fragment>
                          <RenderCustomerDetailsSection
                              checkout={checkout}
                              onCustomerDetailsChange={onCustomerDetailsChange}
                              setOrderNote={setOrderNote}
                              constants={constants}
                          />

                        {!isBusinessCustomer && isAssemblyAllowed && (
                            <CheckoutAssemblyCheckbox
                                withAssembly={withAssembly}
                                setWithAssembly={setWithAssembly}
                            />
                        )}

                        <div>
                          {!authenticated &&
                          (isBusinessCustomer ||
                              checkoutMode ===
                              constants.checkoutMode?.companyCustomers) ? (
                              <button
                                  className="checkout__submit-button button"
                                  onClick={() => (location.href = loginUrl)}
                              >
                                {translate('checkout.login.to.placeorder')}
                              </button>
                          ) : (
                              <button
                                  type="submit"
                                  className="checkout__submit-button button"
                                  disabled={isSubmitting}
                                  onClick={() => placeOrder()}
                              >
                                {translate('checkout.placeorder')}
                              </button>
                          )}
                        </div>
                      </Fragment>
                  )}
                  {privacy && !isBusinessCustomer && (
                      <div className="payment-privacy">
                        <CheckoutCollapse title={translate('checkout.privacy.title')}>
                          <div
                              dangerouslySetInnerHTML={{
                                __html: privacy,
                              }}
                          ></div>
                        </CheckoutCollapse>
                      </div>
                  )}
                </div>
              </div>
            </>
        ) : null}
      </>
  );
};

CheckoutContainer.propTypes = {
  checkout: PropTypes.object,
  setPayment: PropTypes.func,
  setDelivery: PropTypes.func,
  onCustomerDetailsChange: PropTypes.func,
  submit: PropTypes.func,
  submitError: PropTypes.func,
  submitRequest: PropTypes.func,
  cart: PropTypes.object,
  setWithAssembly: PropTypes.func,
  privacy: PropTypes.string,
  setSelectedReseller: PropTypes.func,
  onSignUpChange: PropTypes.func,
  setBonus: PropTypes.func,
  updateOrderRowQuantity: PropTypes.func,
  removeOrderRow: PropTypes.func,
  submitCampaignCode: PropTypes.func,
  setCampaignCode: PropTypes.func,
  signUpForEnjoy: PropTypes.func,
  verify: PropTypes.func,
  setOrderNote: PropTypes.func,
  onCartBuy: PropTypes.func,
  setPaymentAndDelivery: PropTypes.func,
};

const mapStateToProps = (state) => {
  const { cart, checkout } = state;
  return {
    cart,
    checkout,
    constants: window.__litium.constants
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    submit: () => dispatch(submit()),
    setPaymentAndDelivery: (paymentMethod, deliveryMethod) =>
        dispatch(setPaymentAndDelivery(paymentMethod, deliveryMethod)),
    setBusinessCustomer: (value) => dispatch(setBusinessCustomer(value)),
    setCampaignCode: (code) => dispatch(setCampaignCode(code)),
    setCountry: (systemId) => dispatch(setCountry(systemId)),
    setDelivery: (systemId) => dispatch(setDelivery(systemId)),
    setPayment: (systemId) => dispatch(setPayment(systemId)),
    setOrderNote: (note) => dispatch(setOrderNote(note)),
    verify: (url, orderId, payload) => dispatch(verify(url, orderId, payload)),
    onSignUpChange: (signUp) => dispatch(setSignUp(signUp)),
    submitCampaignCode: () => dispatch(submitCampaignCode()),
    setBonus: (bonusToUse) => dispatch(setBonus(bonusToUse)),
    submitRequest: () => dispatch(submitRequest()),
    submitError: (error) => {
      dispatch(submitError(error));
      dispatch(submitDone(null));
    },
    setSelectedReseller: (pickedStore) => {
      const pickedStoreClone = pickedStore ? { ...pickedStore } : null;
      let organizationId = null;

      if (pickedStoreClone && pickedStoreClone.organization) {
        organizationId = pickedStoreClone.organization;
      }

      // Check if pickedStoreClone is not null and not an assembly
      if (pickedStoreClone && !pickedStoreClone.isAssembly) {
        dispatch(setWithAssembly(true));
      }

      // Safely handle the boolean check for isAssembly
      const isAssemblyAllowed = !!(pickedStoreClone && pickedStoreClone.isAssembly);
      dispatch(setIsAssemblyAllowed(isAssemblyAllowed));

      // Dispatch organizationId (which could be null)
      dispatch(setSelectedReseller(organizationId));
    },
    setWithAssembly: (withAssembly) => {
      dispatch(setWithAssembly(withAssembly));
    },
    onCustomerDetailsChange: (stateKey, propName, value) => {
      switch (stateKey) {
        case 'customerDetails':
          dispatch(setCustomerDetails(propName, value));
          break;
        case 'alternativeCompanyAddress':
          dispatch(setAlternativeCompanyAddress(propName, value));
      }
    },

    updateOrderRowQuantity: (rowId, quantity) =>
        dispatch(updateOrderRowQuantity(rowId, quantity)).then(() =>
            dispatch(reloadPayment())
        ),
    removeOrderRow: (rowId) =>
        dispatch(updateOrderRowQuantity(rowId, 0)).then(() =>
            dispatch(reloadPayment())
        ),
    signUpForEnjoy: (checked) => dispatch(signUpForEnjoy(checked)),

    onCartBuy: (articleNumber, quantity, cart) => {
      if (!cart || !cart.orderRows || cart.orderRows.length === 0) {
        dispatch(clearSubmitError());
      }
      addToCartService({
        articleNumber,
        quantity,
      })
          .then((cart) => dispatch(receive(cart)))
          .catch((ex) => {
            dispatch(catchError(ex, (error) => loadError(error)));
          });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutContainer);
